import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, Type } from '@angular/core';
import { ColumnMode, DatatableComponent as NgxDatatable, SelectionType } from '@siemens/ngx-datatable';
import {
  DEFAULT_LIMIT,
  NkDatatableColumn,
  NkDatatableDetails,
  NkDatatablePagination,
  SelectRowEvent,
} from './datatable.utils';

@Component({
  selector: 'nk-datatable',
  templateUrl: './datatable.component.html',
  styleUrls: ['./datatable.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class DatatableComponent<T> {
  @Input() public rows: T[] = [];
  @Input() public columns: NkDatatableColumn<T>[] = [];
  @Input() public selected: T[] = [];
  @Input() public emptyMessage: string | null = null;
  @Input() public loading = false;
  /*
    A function you can use to check whether you want to show the checkbox for a particular row based on a criteria.
  */
  @Input() public displayCheckFn: NgxDatatable['displayCheck'] | null = null;
  @Input() public headerCheckboxable = false;
  @Input() public checkboxable = true;
  @Input() public pagination!: NkDatatablePagination;
  @Input() public highlightText?: string;
  @Input() public footerHeight = 50;
  @Input() public datatableDetailsComponent!: Type<NkDatatableDetails<T>>;
  @Output() public selectRow = new EventEmitter<SelectRowEvent<T>>();
  @Output() public changePageOffset = new EventEmitter<number>();
  public columnMode = ColumnMode;
  public selectionType = SelectionType;
  public isAllCompaniesSelected = false;
  public defaultLimit = DEFAULT_LIMIT;
  public onSelect({ selected }: { selected: T[] }): void {
    this.selected = [...selected];
  }

  public onActivate(event: MouseEvent & { row: T }): void {
    if (event.type === 'checkbox') {
      const action = this.selected.find((i) => i === event.row) ? 'checked' : 'unchecked';
      const selectedRow: SelectRowEvent<T> = {
        action,
        row: event.row,
        fullSelection: this.selected,
      };
      this.selectRow.emit(selectedRow);
    }
  }

  public toggleExpandRow(datatable: NgxDatatable, row: T): void {
    datatable.rowDetail.toggleExpandRow(row);
  }

  public onDetailToggle(event: unknown): void {}

  public setPage(pageOptions: { count: number; limit: number; offset: number; pageSize: number }): void {
    this.changePageOffset.emit(pageOptions.offset);
  }
}
